import styles from "../login-box/login.module.scss";
import ButtonC from "../../common/button";
import { redirectUri } from "../../../utils/utils";

const LoginC = () => {
  const handleLogin = () => {
    window.location.href = `${
      process.env.REACT_APP_SALESFORCE_BASE_URL
    }/services/oauth2/authorize?response_type=code&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&client_id=${process.env.REACT_APP_SALESFORCE_CLIENT_ID}`;
  };
  return (
    <div className={styles.loginBox}>
      <div className={styles.welcomeText}>
        <div className={styles.title}>Welcome Back!</div>
      </div>
      <div className={styles.heading}>
        <img src="/images/logo.svg" alt="" className={styles.logo} />
        <div className={styles.title}>Clarity</div>
      </div>
      <div className={styles.loginBtn}>
        <ButtonC
          type="button"
          icon={
            <img
              src="/images/salesforce.svg"
              className={styles.salesforceIcon}
              alt="salesforce"
            />
          }
          btnType={"withIcon"}
          className={styles.SalesforceBtn}
          label="Log in with Salesforce"
          bgColor={"blueBg"}
          iconPos={"left"}
          tabIndex={1}
          onClick={handleLogin}
        />
      </div>
    </div>
  );
};

export default LoginC;
